import { useRouter } from 'next/router';

export const useParamsUrlFromApps = () => {
  const { query } = useRouter();
  const { isFromApps } = query as { isFromApps: string };

  return { isFromApps: isFromApps === 'true' };
};
